import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import logo from '../../assets/images/auth/pro_mis_logo.svg';
import uuidV4 from 'uuid/v4';
import useStyles from "./styles";
import {AccessKey} from "@cabinet-packages/helpers";
import {useDispatch} from "react-redux";
import {selectActivePatient, setListOfPatients} from "@cabinet-packages/redux";
import {useHistory} from "react-router";
import {CircularProgress} from "@material-ui/core";
import {acceptPartner, authorisePartner} from "@cabinet-packages/api";

function Copyright({className}) {
    return (
        <Typography className={className}>
            IT підтримка{' '}
            <a
                href="https://mz-group.com.ua/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'inherit', textDecoration: 'none' }}
            >
                MZ Group
            </a>{' '}
            {new Date().getFullYear()}
        </Typography>
    );
}

export default function Authentication() {
    const cl = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [error, setError] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isAuthorise, setIsAuthorise] = useState(false);
    const [{uuid, username, password, code}, setCredentials] = useState({uuid: uuidV4(), username: '', password: '', code: ''});

    const handleChange = (e) => {
        e.persist();
        if (e.target.name === 'code' && e.target.value.length > 4) return;
        setCredentials(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }))
    };

    const handleAccept = async (acceptCode) => {
        setLoading(true);
        setError(false);
        try {
            const {data} = await acceptPartner(uuid, acceptCode || code);
            AccessKey.set(data.accessToken);
            dispatch(setListOfPatients(false, false, [data.user]));
            dispatch(selectActivePatient(data.user));
            setCredentials(prevState => ({...prevState, code: ''}));
            setLoading(false);
            history.push('/catalog');
        } catch (e) {
            console.error(e);
            setIsAuthorise(false);
            setError('Невірно введений код.')
            setCredentials(prevState => ({...prevState, code: ''}));
            setLoading(false);
        }
    }

    const handleAuthorise = async () => {
        setLoading(true);
        setError(false);
        setErrorPassword(false);

        try {
            const data = await authorisePartner(uuid, username, password);

            if (data) {
                await handleAccept(data.data.code)
            }
            setIsAuthorise(true);
        } catch (e) {
            if (e.response && e.response.data && e.response.data.message === 'Password did not match') {
                setErrorPassword('Невірний пароль.');
            } else if (e.response && e.response.data && e.response.data.message === 'User not found')  {
                setErrorPassword('Невірний логін.')
            } else {
                setErrorPassword('Вибачте, виникла помилка.');
            }
            console.error(e)
        }

        setLoading(false);
    };

    const handleAuthoriseSubmit = (e) => {
        e.preventDefault();
        if (!loading && username.length && password.length) {
            handleAuthorise();
        }
    };

    const handleAcceptSubmit = (e) => {
        e.preventDefault();
        if (!loading && code.length) {
            handleAccept();
        }
    };

    return (
        <div className={cl.root}>
            <div className={cl.leftSection}>
                <div className={cl.formContainer}>
                    <img src={logo} className={cl.logo} alt="Pro MIS Logo" />
                    <Typography className={cl.title}>
                        Вхід для пунктів
                    </Typography>
                    <Typography className={cl.subtitle}>
                        Вітаємо! Введіть дані для входу.
                    </Typography>

                    {isAuthorise ? (
                        <form className={cl.form} onSubmit={handleAcceptSubmit}>
                            {/*<label className={cl.inputLabel}>*/}
                            {/*    Код <span className="required">*</span>*/}
                            {/*</label>*/}
                            {/*<TextField*/}
                            {/*    variant="outlined"*/}
                            {/*    fullWidth*/}
                            {/*    id="code"*/}
                            {/*    name="code"*/}
                            {/*    placeholder="Введіть код"*/}
                            {/*    autoFocus*/}
                            {/*    value={code}*/}
                            {/*    onChange={handleChange}*/}
                            {/*    disabled={loading}*/}
                            {/*    className={cl.textField}*/}
                            {/*/>*/}
                            {error && <p className={cl.errorText}>{error}</p>}
                            <Button
                                fullWidth
                                variant="contained"
                                className={cl.submitButton}
                                onClick={()=>window.location.reload()}
                            >
                                Повторити вхід
                            </Button>
                            {/*<Button*/}
                            {/*    fullWidth*/}
                            {/*    variant="contained"*/}
                            {/*    className={cl.submitButton}*/}
                            {/*    disabled={loading || !code.length}*/}
                            {/*    type="submit"*/}
                            {/*>*/}
                            {/*    Підтвердити код*/}
                            {/*</Button>*/}
                            {loading && (
                                <div className={cl.loading}>
                                    <CircularProgress size={24} />
                                </div>
                            )}
                        </form>
                    ) : (
                        <form className={cl.form} onSubmit={handleAuthoriseSubmit}>
                            <label className={cl.inputLabel}>
                                Логін <span className="required">*</span>
                            </label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="username"
                                name="username"
                                placeholder="Введіть ваш імейл/номер телефону?"
                                autoFocus
                                value={username}
                                onChange={handleChange}
                                disabled={loading}
                                className={cl.textField}
                            />
                            <label className={cl.inputLabel}>
                                Пароль <span className="required">*</span>
                            </label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="password"
                                type="password"
                                id="password"
                                placeholder="Введіть пароль"
                                value={password}
                                onChange={handleChange}
                                disabled={loading}
                                className={cl.textField}
                            />
                            {error && <p className={cl.errorText}>{error}</p>}
                            {errorPassword && <p className={cl.errorText}>{errorPassword}</p>}
                            <Button
                                fullWidth
                                variant="contained"
                                className={cl.submitButton}
                                disabled={loading || !username.length || !password.length}
                                type="submit"
                            >
                                Авторизуватись
                            </Button>
                            <Copyright className={cl.footer} />
                            {loading && (
                                <div className={cl.loading}>
                                    <CircularProgress size={24} />
                                </div>
                            )}
                        </form>
                    )}
                </div>
            </div>
            <div className={cl.rightSection} />
        </div>
    );
}
